
import axios from "axios";
import jsonData from './../../../assest/json/messages.json';

const { validate, clean } = require('rut.js')
const basePathAPIReclamos = process.env.REACT_APP_BASE_PATH_APIRECLAMOS_SERVICE;
const heder = {
    'Content-Type': 'application/json',
    'inCanal': '7'
}
const params = window.location.host.toString();
const empParam = new URLSearchParams(window.location.search);
const emp = empParam.get('e')
let textos = obtenerTextos();
/**
 * 
 * Consultas a API
 * 
 */
export async function obtenerMotivo(codigo_web) {
    let response = {
        inStep: '',
        status: "",
        mensaje: '',
        texto: '',
        data: []
    }
    let mensajeria = await textos;
    try {

        let servicio = 'obtenerMotivo'

        let url = basePathAPIReclamos + servicio + '?cod_web=' + codigo_web;

        await axios.get(url, {
            headers: heder
        })
            .then((res) => {

                response.inStep = 1;
                response.retorno = 0;
                response.mensaje = mensajeria.data.messages.obtenerMotivo.success.titulo;
                response.texto = mensajeria.data.messages.obtenerMotivo.success.message;
                response.status = "success";
                response.data = res.data;

            }).catch((error) => {

                response.inStep = 3;
                response.retorno = 0;
                response.mensaje = mensajeria.data.messages.obtenerMotivo.error.titulo;
                response.texto = mensajeria.data.messages.obtenerMotivo.error.message;
                response.status = "warning";
            })
    } catch (error) {

        response.inStep = 3;
        response.retorno = 0;
        response.mensaje = mensajeria.data.messages.obtenerMotivo.fatal.titulo;
        response.texto = mensajeria.data.messages.obtenerMotivo.fatal.message;
        response.status = "error";
        response.data = error;

    }
    return response;
}

export async function obtenerSubMotivo(familia_tipo) {

    let response = {
        inStep: '',
        status: "",
        mensaje: '',
        texto: '',
        data: []
    }
    let mensajeria = await textos;
    try {

        let servicio = 'obtenerSubMotivo'

        let url = basePathAPIReclamos + servicio + '?familia_tipo=' + familia_tipo;

        await axios.get(url, {
            headers: heder
        })
            .then((res) => {

                response.inStep = 1;
                response.mensaje = mensajeria.data.messages.obtenerSubMotivo.success.titulo;
                response.texto = mensajeria.data.messages.obtenerSubMotivo.success.message;
                response.status = "success"
                response.data = res.data

            }).catch((error) => {

                response.inStep = 3;
                response.mensaje = mensajeria.data.messages.obtenerSubMotivo.error.titulo;
                response.texto = mensajeria.data.messages.obtenerSubMotivo.error.message;
                response.status = "warning"
            })

        return response;

    } catch (error) {

        response.inStep = 3;
        response.mensaje = mensajeria.data.messages.obtenerSubMotivo.fatal.titulo;
        response.texto = mensajeria.data.messages.obtenerSubMotivo.fatal.message;
        response.status = "error"
        response.data = error

        return response;
    }
}

export async function obtenerTipoReclamo(subfamilia_tipo, tipo_rec_web, estado_tipo) {

    let response = {
        inStep: '',
        status: "",
        mensaje: '',
        texto: '',
        data: []
    }
    let mensajeria = await textos;
    try {

        let servicio = 'obtenerTipoReclamo'

        let url = basePathAPIReclamos + servicio + '?subfamilia_tipo=' + subfamilia_tipo
            + '&tipo_rec_web=' + tipo_rec_web
            + '&estado_tipo=' + estado_tipo;

        await axios.get(url, {
            headers: heder
        })
            .then((res) => {

                response.inStep = 1;
                response.mensaje = mensajeria.data.messages.obtenerTipoReclamo.fatal.titulo;
                response.texto = mensajeria.data.messages.obtenerTipoReclamo.fatal.message;
                response.status = "success"
                response.data = res.data

            }).catch((error) => {

                response.inStep = 3;
                response.mensaje = mensajeria.data.messages.obtenerTipoReclamo.error.titulo;
                response.texto = mensajeria.data.messages.obtenerTipoReclamo.error.message;
                response.status = "warning"
            })

        return response;

    } catch (error) {

        response.inStep = 3;
        response.mensaje = mensajeria.data.messages.obtenerTipoReclamo.fatal.titulo;
        response.texto = mensajeria.data.messages.obtenerTipoReclamo.fatal.message;
        response.status = "error"
        response.data = error

        return response;
    }
}

export async function enviarFormulario(form) {

    let response = {
        inStep: '',
        status: "",
        mensaje: '',
        texto: '',
        data: []
    }
    let mensajeria = await textos;

    let bole = [];
    let servicio = 'enviarReclamo'
    let url = basePathAPIReclamos + servicio;

    if (form.bole1 !== null) {
        bole.push(form.bole1);
    }
    if (form.bole2 !== null) {
        bole.push(form.bole2);
    }
    if (form.bole3 !== null) {
        bole.push(form.bole3);
    }

    form.bole = bole;


    try {
        await axios.post(url, form, {
            headers: heder
        }).then((res) => {

            let num_reclamo = res.data.numero_reclamo
            let mensaje;
            let texto;
            let status;

            switch (num_reclamo) {
                case 1:
                    mensaje = mensajeria.data.messages.enviarFormulario.success.uno.titulo;
                    texto = mensajeria.data.messages.enviarFormulario.success.uno.message;
                    status = "warning";
                    break;
                case 2:
                    mensaje = mensajeria.data.messages.enviarFormulario.success.dos.titulo;
                    texto = mensajeria.data.messages.enviarFormulario.success.dos.message;
                    status = "warning";
                    break;
                case 3:
                    mensaje = mensajeria.data.messages.enviarFormulario.success.tres.titulo;
                    texto = mensajeria.data.messages.enviarFormulario.success.tres.message;
                    status = "warning";
                    break;
                case 4:
                    mensaje = mensajeria.data.messages.enviarFormulario.success.cuatro.titulo;
                    texto = mensajeria.data.messages.enviarFormulario.success.cuatro.message;
                    status = "warning";
                    break;
                default:
                    mensaje = mensajeria.data.messages.enviarFormulario.success.cero.titulo;
                    texto = mensajeria.data.messages.enviarFormulario.success.cero.message;
                    status = "success";
                    break;
            }

            response.inStep = 3;
            response.mensaje = mensaje;
            response.texto = texto;
            response.status = status;
            response.data = res.data

        }).catch((error) => {
            response.inStep = 3;
            response.mensaje = mensajeria.data.messages.enviarFormulario.error.titulo;
            response.texto = mensajeria.data.messages.enviarFormulario.error.message;
            response.status = "warning"
            response.data = form
        })
    } catch (error) {
        response.inStep = 3;
        response.mensaje = mensajeria.data.messages.enviarFormulario.fatal.titulo;
        response.texto = mensajeria.data.messages.enviarFormulario.fatal.message;
        response.status = "error"
        response.data = form
    }

    return response;
}

export async function enviarFormularioDevolucion(formulario) {

    let response = {
        inStep: '',
        status: "",
        mensaje: '',
        texto: '',
        data: []
    }
    let mensajeria = await textos;

    let servicio = 'enviarDevolucion'
    let url = basePathAPIReclamos + servicio;


    try {
        await axios.post(url, formulario, {
            headers: heder
        }).then((res) => {

            let num_reclamo = res.data.numero_reclamo
            let mensaje;
            let texto;
            let status;

            switch (num_reclamo) {
                case 1:
                    mensaje = mensajeria.data.messages.enviarFormulario.success.uno.titulo;
                    texto = mensajeria.data.messages.enviarFormulario.success.uno.message;
                    status = "warning";
                    break;
                case 2:
                    mensaje = mensajeria.data.messages.enviarFormulario.success.dos.titulo;
                    texto = mensajeria.data.messages.enviarFormulario.success.dos.message;
                    status = "warning";
                    break;
                case 3:
                    mensaje = mensajeria.data.messages.enviarFormulario.success.tres.titulo;
                    texto = mensajeria.data.messages.enviarFormulario.success.tres.message;
                    status = "warning";
                    break;
                case 4:
                    mensaje = mensajeria.data.messages.enviarFormulario.success.cuatro.titulo;
                    texto = mensajeria.data.messages.enviarFormulario.success.cuatro.message;
                    status = "warning";
                    break;
                default:
                    mensaje = mensajeria.data.messages.enviarFormulario.success.cero.titulo;
                    texto = mensajeria.data.messages.enviarFormulario.success.cero.message;
                    status = "success";
                    break;
            }

            response.inStep = 3;
            response.mensaje = mensaje;
            response.texto = texto;
            response.status = status;
            response.data = res.data

        }).catch((error) => {
            response.inStep = 3;
            response.mensaje = mensajeria.data.messages.enviarFormulario.error.titulo;
            response.texto = mensajeria.data.messages.enviarFormulario.error.message;
            response.status = "warning"
            response.data = formulario
        })
    } catch (error) {
        response.inStep = 3;
        response.mensaje = mensajeria.data.messages.enviarFormulario.fatal.titulo;
        response.texto = mensajeria.data.messages.enviarFormulario.fatal.message;
        response.status = "error"
        response.data = formulario
    }

    return response;
}

export async function obtenerReclamo(numero_reclamo, tipo_consulta, rut_solicitante, dv_solicitante, empresa) {

    let response = {
        inStep: '',
        status: "",
        mensaje: '',
        texto: '',
        data: []
    }
    let mensajeria = await textos;
    try {

        let servicio = 'obtenerReclamo'

        let url = basePathAPIReclamos + servicio +
            '?numero_reclamo=' + numero_reclamo
            + '&tipo_consulta=' + tipo_consulta
            + '&rut_solicitante=' + rut_solicitante
            + '&dv_solicitante=' + dv_solicitante
            + '&empresa=' + empresa;

        await axios.get(url, {
            headers: heder
        })
            .then((res) => {

                let num_reclamo = res.data.numero_reclamo
                let status;

                switch (num_reclamo) {
                    case 1:
                        response.mensaje = mensajeria.data.messages.obtenerReclamo.success.uno.titulo;
                        response.texto = mensajeria.data.messages.obtenerReclamo.success.uno.message;
                        status = "warning";
                        break;
                    case 2:
                        response.mensaje = mensajeria.data.messages.obtenerReclamo.success.dos.titulo;
                        response.texto = mensajeria.data.messages.obtenerReclamo.success.dos.message;
                        status = "warning";
                        break;
                    default:
                        response.mensaje = mensajeria.data.messages.obtenerReclamo.success.cero.titulo.replace("numero_solicitud", res.data.numero_reclamo);
                        response.texto = res.data.descripcion;
                        status = "success";
                        break;
                }

                response.inStep = 3;
                response.status = status;
                response.data = res.data;

            }).catch((error) => {

                response.inStep = 3;
                response.mensaje = mensajeria.data.messages.obtenerReclamo.error.titulo;
                response.texto = mensajeria.data.messages.obtenerReclamo.error.message;
                response.status = "warning"
            })
    } catch (error) {

        response.inStep = 3;
        response.mensaje = mensajeria.data.messages.obtenerReclamo.fatal.titulo;
        response.texto = mensajeria.data.messages.obtenerReclamo.fatal.message;
        response.status = "error"
        response.data = error

    }
    return response;
}

export async function obtenerBoletosByTransaccion(numeroTransaccion, validacion) {
    let response = {
        inStep: '',
        status: "",
        mensaje: '',
        texto: '',
        codigoFormaDePago: 0,
        data: [],
        datosComprador: []
    }
    let estructuraBoleto = {
        id: null,
        detalle: null
    }
    let comprador = {
        rut: null,
        dv: null,
        nombre: null,
        apellidoPaterno: null,
        apellidoMaterno: null,
    }
    let mensajeria = await textos;
    let detalleBoleto = []

    try {

        let servicio = 'vtwst99'
        let params = "?inTipoOperacion=1"
            + "&inNumeroOperacion=" + numeroTransaccion
            + "&inLineaComercio=" + await obtenerCodigoLinea();

        let url = basePathAPIReclamos + servicio + params;
        if (numeroTransaccion !== null && !validacion) {
            await axios.get(url, {
                headers: heder
            })
                .then((res) => {
                    response.retorno = 0;
                    response.mensaje = mensajeria.data.messages.obtenerMotivo.success.titulo;
                    response.texto = mensajeria.data.messages.obtenerMotivo.success.message;
                    response.status = "success";
                    res.data.forEach(boleto => {

                        response.codigoFormaDePago = boleto.outCodigoFormaPago;
                        estructuraBoleto = { id: null, detalle: null };

                        estructuraBoleto.id = boleto.outNumeroBoleto;
                        estructuraBoleto.detalle = boleto.outNumeroBoleto + " - $" + boleto.outValorBoleto + " - " + boleto.outNmnTerminalSalida.split("-")[0] + " - " + boleto.outNmnTerminalLlegada.split("-")[0] + " - " + boleto.outFechaSalidaTramo + " " + boleto.outHoraSalidaTramo
                        comprador.nombre = boleto.outNombreComprador;
                        comprador.apellidoPaterno = boleto.outApPaternoComprador;
                        comprador.apellidoMaterno = boleto.outApMaternoComprador;
                        comprador.rut = boleto.outNroDocumentoComprador;
                        comprador.dv = boleto.outDigVerificadorComprador;

                        detalleBoleto.push(estructuraBoleto);

                    });

                    response.data = detalleBoleto;
                    response.datosComprador = comprador;
                }).catch((error) => {

                    response.inStep = 3;
                    response.retorno = 0;
                    response.mensaje = mensajeria.data.messages.obtenerMotivo.error.titulo;
                    response.texto = mensajeria.data.messages.obtenerMotivo.error.message;
                    response.status = "warning";
                })
        }
    } catch (error) {

        response.inStep = 3;
        response.retorno = 0;
        response.mensaje = mensajeria.data.messages.obtenerMotivo.fatal.titulo;
        response.texto = mensajeria.data.messages.obtenerMotivo.fatal.message;
        response.status = "error";
        response.data = error;

    }
    return response;
}

/**
 * 
 * Utilidades
 * 
 */
export async function formatearRut(rut) {
    let rutClean = clean(rut)
    let rutFormateado = validate(rutClean)
    return rutFormateado;
}

export async function valRut(event) {

    let validaciones = {
        rut: null,
        dv: null,
        txtSpan: null,
        activeSpan: false
    }
    let mensajeria = await textos;

    let rut = clean(event.target.value)
    let rutFormateado = validate(rut)

    if (rutFormateado && rut.length >= 8) {

        validaciones.rut = clean(rut).slice(0, -1);
        validaciones.dv = clean(rut).slice(-1);
        validaciones.txtSpan = null;
        validaciones.activeSpan = false;

    } else if (rut.length >= 2) {

        validaciones.rut = null;
        validaciones.dv = null;
        validaciones.txtSpan = mensajeria.data.validations.rut.message_2;
        validaciones.activeSpan = true;

    } else {

        validaciones.rut = null;
        validaciones.dv = null;
        validaciones.txtSpan = mensajeria.data.validations.rut.message_1;
        validaciones.activeSpan = true;

    }

    return validaciones;

}

export async function valMail(event) {

    let validaciones = {
        correo: null,
        txtSpan: null,
        activeSpan: false
    }
    let mensajeria = await textos;

    let correo = event.target.value

    if (correo.length >= 3) {

        let lastAtPos = correo.lastIndexOf('@');
        let lastDotPos = correo.lastIndexOf('.');

        if (lastAtPos >= 2 && lastDotPos >= 2 && (lastDotPos - lastAtPos >= 3) && (lastDotPos - correo.length) < -2) {

            validaciones.activeSpan = false;
            validaciones.txtSpan = null;
            validaciones.correo = correo;

        } else {

            validaciones.activeSpan = true;
            validaciones.txtSpan = mensajeria.data.validations.correo.message_2;
            validaciones.correo = null;

        }
    } else {

        validaciones.activeSpan = true;
        validaciones.txtSpan = mensajeria.data.validations.correo.message_1;
        validaciones.correo = null;
    }

    return validaciones;
}

export async function valNombre(event) {

    let mensajeria = await textos;
    let validaciones = {
        texto: null,
        txtSpan: null,
        activeSpan: false
    }

    let texto = event.target.value
    let id = event.target.id;


    if (texto.length >= 3) {

        validaciones.activeSpan = false;
        validaciones.txtSpan = null;
        validaciones.texto = texto;

    } else {

        switch (id) {
            case "numticketsoli":
                if (texto.length < 1) {
                    validaciones.texto = null;
                    validaciones.txtSpan = null;
                    validaciones.activeSpan = false;
                } else {
                    validaciones.texto = null;
                    validaciones.txtSpan = mensajeria.data.validations.ticket.message;
                    validaciones.activeSpan = true;
                }
                break;
            case "appatcomp":
            case "apmatcomp":
            case "appatsoli":
            case "apmatsoli":
                validaciones.activeSpan = true;
                validaciones.txtSpan = mensajeria.data.validations.apellido.message;
                validaciones.texto = null;
                break;
            case "nomcomp":
            case "nomsoli":
                validaciones.activeSpan = true;
                validaciones.txtSpan = mensajeria.data.validations.nombre.message;
                validaciones.texto = null;
                break;
            default:
                validaciones.activeSpan = true;
                validaciones.txtSpan = 'Ingrese un valor valido.';
                validaciones.texto = null;
                break;
        }
    }

    return validaciones;
}

export async function valTexto(event) {

    let validaciones = {
        texto: null,
        txtSpan: null,
        activeSpan: false,
        activaCon: false,
        txtCon: null
    }
    let mensajeria = await textos;

    let texto = event.target.value;
    let maxLength = event.target.maxLength !== undefined ? event.target.maxLength : 1050;
    let count = (maxLength - texto.length);

    if (texto.length > 0) {

        validaciones.activeSpan = false;
        validaciones.txtSpan = null;
        validaciones.texto = texto;
        validaciones.activaCon = true;
        validaciones.txtCon = mensajeria.data.validations.comentario.message_2.replace("count", count);

    } else {

        validaciones.activeSpan = true;
        validaciones.txtSpan = mensajeria.data.validations.comentario.message_1;
        validaciones.texto = null;
        validaciones.activaCon = true;
        validaciones.txtCon = mensajeria.data.validations.comentario.message_2.replace("count", count);

    }

    return validaciones;
}

export async function valNumero(event) {

    let validaciones = {
        numero: null,
        txtSpan: null,
        activeSpan: false
    }
    let mensajeria = await textos;
    let id = event.target.id;
    let number = event.target.value;

    switch (id) {
        case "soli":
            if (number.length > 4) {
                validaciones.numero = number;
                validaciones.txtSpan = null;
                validaciones.activeSpan = false;
            } else {
                validaciones.numero = null;
                validaciones.txtSpan = mensajeria.data.validations.solicitud.message;
                validaciones.activeSpan = true;
            }
            break;
        case "trxsoli":
            if (number.length > 0) {
                if (number.length >= 8) {
                    validaciones.numero = number;
                    validaciones.txtSpan = null;
                    validaciones.activeSpan = false;
                } else {
                    validaciones.numero = null;
                    validaciones.txtSpan = mensajeria.data.validations.transaccion.message;
                    validaciones.activeSpan = true;
                }
            } else {
                validaciones.numero = null;
                validaciones.txtSpan = null;
                validaciones.activeSpan = false;

            }
            break;
        case "numbol1":
        case "numbol2":
        case "numbol3":
            if (number.length > 0) {
                if (number.length >= 9) {

                    validaciones.numero = number;
                    validaciones.txtSpan = null;
                    validaciones.activeSpan = false;

                } else {

                    validaciones.numero = null;
                    validaciones.txtSpan = mensajeria.data.validations.boleto.message;
                    validaciones.activeSpan = true;

                }
            } else {

                validaciones.numero = null;
                validaciones.txtSpan = null;
                validaciones.activeSpan = false;

            }
            break;
        case "telesoli":
            if (number.length > 0) {
                if (number.length >= 7) {

                    validaciones.numero = number;
                    validaciones.txtSpan = null;
                    validaciones.activeSpan = false;

                } else {

                    validaciones.numero = null;
                    validaciones.txtSpan = mensajeria.data.validations.telefono.message;
                    validaciones.activeSpan = true;

                }
            } else {

                validaciones.numero = null;
                validaciones.txtSpan = null;
                validaciones.activeSpan = false;

            }
            break;
        case "celsoli":
            if (number.length >= 9) {

                validaciones.numero = number;
                validaciones.txtSpan = null;
                validaciones.activeSpan = false;

            } else {

                validaciones.numero = null;
                validaciones.txtSpan = mensajeria.data.validations.celular.message;
                validaciones.activeSpan = true;

            }
            break;
        case "cuenta":

            if (number.length > 0) {
                if (number.length >= 3) {

                    validaciones.numero = number;
                    validaciones.txtSpan = null;
                    validaciones.activeSpan = false;

                } else {

                    validaciones.numero = null;
                    validaciones.txtSpan = mensajeria.data.validations.cuenta.message;
                    validaciones.activeSpan = true;

                }
            } else {

                validaciones.numero = null;
                validaciones.txtSpan = null;
                validaciones.activeSpan = false;

            }
            break;
        default:
            break;
    }

    return validaciones;
}

export async function valCaptcha(captcha) {

    let validaciones = {
        verifyCaptcha: false,
        activeSpan: false
    }
    let mensajeria = await textos;

    if (captcha) {
        validaciones.verifyCaptcha = true;
        validaciones.txtSpan = null;
    } else {
        validaciones.txtSpan = mensajeria.data.validations.verificarCaptcha.message;
        validaciones.activeSpan = true;
    }

    return validaciones;

}

export async function valForm(form) {

    let validaciones = {
        motivoSpan: null,
        motivoTxt: null,
        subMotivoSpan: null,
        subMotivoTxt: null,
        tipoReclamoSpan: null,
        tipoReclamoTxt: null,
        nombreSpan: null,
        nombreTxt: null,
        apPatSpan: null,
        apPatTxt: null,
        apMatSpan: null,
        apMatTxt: null,
        rutSpan: null,
        rutTxt: null,
        correoSpan: null,
        correoTxt: null,
        telefonoSpan: null,
        telefonoTxt: null,
        celularSpan: null,
        celularTxt: null,
        ticketSpan: null,
        ticketTxt: null,
        transaccionSpan: null,
        transaccionTxt: null,
        bole1Span: null,
        bole1Txt: null,
        bole2Span: null,
        bole2Txt: null,
        bole3Span: null,
        bole3Txt: null,
        comentarioSpan: null,
        comentarioTxt: null,
        validacion: true
    }
    let mensajeria = await textos;

    if (form.motivo === null) {
        validaciones.motivoSpan = true;
        validaciones.motivoTxt = mensajeria.data.validations.motivo.message;
        validaciones.validacion = false;

    }

    if (form.subMotivo === null) {
        validaciones.subMotivoSpan = true;
        validaciones.subMotivoTxt = mensajeria.data.validations.submotivo.message;
        validaciones.validacion = false;
    }

    if (form.tipoReclamo === null) {
        validaciones.tipoReclamoSpan = true;
        validaciones.tipoReclamoTxt = mensajeria.data.validations.tiporeclamo.message;
        validaciones.validacion = false;
    }

    if (form.nombre === null) {
        validaciones.nombreSpan = true;
        validaciones.nombreTxt = mensajeria.data.validations.nombre.message;
        validaciones.validacion = false;
    }

    if (form.apPat === null) {
        validaciones.apPatSpan = true;
        validaciones.apPatTxt = mensajeria.data.validations.apellido.message;
        validaciones.validacion = false;
    }

    if (form.apMat === null) {
        validaciones.apMatSpan = true;
        validaciones.apMatTxt = mensajeria.data.validations.apellido.message;
        validaciones.validacion = false;
    }

    if (form.rut === null) {
        validaciones.rutSpan = true;
        validaciones.rutTxt = mensajeria.data.validations.rut.message_1;
        validaciones.validacion = false;
    }

    if (form.correo === null) {
        validaciones.correoSpan = true;
        validaciones.correoTxt = mensajeria.data.validations.correo.message_1;
        validaciones.validacion = false;
    }

    if (form.celular === null) {
        validaciones.celularSpan = true;
        validaciones.celularTxt = mensajeria.data.validations.celular.message;
        validaciones.validacion = false;
    }

    if (form.comentario === null) {
        validaciones.comentarioSpan = true;
        validaciones.comentarioTxt = mensajeria.data.validations.comentario.message_1;
        validaciones.validacion = false;
    }

    return validaciones;
}

export async function validaEstados(estado) {

    let valido = false;

    if (!estado.activarSpanMotivo && !estado.activarSpanSubMotivo && !estado.activarSpanTipoReclamo &&
        !estado.activarSpanNombre && !estado.activarSpanApPat && !estado.activarSpanApMat &&
        !estado.activarSpanRut && !estado.activarSpanCorreo && !estado.activarSpanTelefono &&
        !estado.activarSpanCelular && !estado.activarSpanTicket && !estado.activarSpanTrx &&
        !estado.activarSpanBol1 && !estado.activarSpanBol2 && !estado.activarSpanBol3 &&
        !estado.activarSpanComentario && !estado.verificarCaptcha) {
        valido = true;
    }

    return valido;
}

export async function validaFormularioDevoluciones(formulario) {


    let validaciones = {
        comprador: {
            rut: {
                estado: false,
                mensaje: ""
            },
            nombre: {
                estado: false,
                mensaje: ""
            },
            apellidoPaterno: {
                estado: false,
                mensaje: ""
            },
            apellidoMaterno: {
                estado: false,
                mensaje: ""
            }
        },
        solicitante: {
            rut: {
                estado: false,
                mensaje: ""
            },
            nombre: {
                estado: false,
                mensaje: ""
            },
            apellidoPaterno: {
                estado: false,
                mensaje: ""
            },
            apellidoMaterno: {
                estado: false,
                mensaje: ""
            },
            telefono: {
                estado: false,
                mensaje: ""
            },
            celular: {
                estado: false,
                mensaje: ""
            },
            correo: {
                estado: false,
                mensaje: ""
            }
        },
        cuenta: {
            banco: {
                estado: false,
                mensaje: ""
            },
            tipo: {
                estado: false,
                mensaje: ""
            },
            numero: {
                estado: false,
                mensaje: ""
            }
        },
        venta: {
            transaccion: {
                estado: false,
                mensaje: ""
            },
            ticket: {
                estado: false,
                mensaje: ""
            }
        },
        reclamo: {
            comentario: {
                estado: false,
                mensaje: ""
            },
            tipoDeDevolucion: {
                estado: false,
                mensaje: ""
            }
        },
        boleto: {
            boletosAnular: {
                estado: false,
                mensaje: ""
            }
        },
        validacion: true
    }
    let mensajeria = await textos;
    let comprador = formulario.reclamo.comprador;
    let solicitante = formulario.reclamo.solicitante;
    let venta = formulario.reclamo.detalleVenta;
    let reclamo = formulario.reclamo.detalleReclamo;
    let boleto = formulario.reclamo.boleto;
    let alertaComprador = formulario.alerta.estado.comprador;
    let alertaSolicitante = formulario.alerta.estado.solicitante;
    let alertaCuenta = formulario.alerta.estado.cuenta;
    let alertaVenta = formulario.alerta.estado.venta;
    let alertaReclamo = formulario.alerta.estado.reclamo;
    let alertaBoletooleto = formulario.alerta.estado.boleto;


    validaciones.validacion = !alertaComprador.rut && !alertaComprador.nombre && !alertaComprador.apellidoPaterno && !alertaComprador.apellidoMaterno && !alertaSolicitante.rut && !alertaSolicitante.nombre &&
        !alertaSolicitante.apellidoPaterno && !alertaSolicitante.apellidoMaterno && !alertaSolicitante.telefono && !alertaSolicitante.celular && !alertaSolicitante.correo && !alertaCuenta.banco &&
        !alertaCuenta.tipo && !alertaCuenta.numero && !alertaVenta.transaccion && !alertaReclamo.comentario && !alertaBoletooleto.boletosAnular ? validaciones.validacion : false;

    if (comprador.rut === null | comprador.rut === '' && reclamo.tipoDeDevolucion === 2) {
        validaciones.comprador.rut.estado = true;
        validaciones.comprador.rut.mensaje = mensajeria.data.validations.rut.message_2;
        validaciones.validacion = false;
    }

    if (comprador.nombre === null | comprador.nombre === '' && reclamo.tipoDeDevolucion === 2) {
        validaciones.comprador.nombre.estado = true;
        validaciones.comprador.nombre.mensaje = mensajeria.data.validations.nombre.message;
        validaciones.validacion = false;
    }

    if (comprador.apellidoPaterno === null | comprador.apellidoPaterno === '' && reclamo.tipoDeDevolucion === 2) {
        validaciones.comprador.apellidoPaterno.estado = true;
        validaciones.comprador.apellidoPaterno.mensaje = mensajeria.data.validations.apellido.message;
        validaciones.validacion = false;
    }

    if (comprador.apellidoMaterno === null | comprador.apellidoMaterno === '' && reclamo.tipoDeDevolucion === 2) {
        validaciones.comprador.apellidoMaterno.estado = true;
        validaciones.comprador.apellidoMaterno.mensaje = mensajeria.data.validations.apellido.message;
        validaciones.validacion = false;
    }

    if (solicitante.rut === null) {
        validaciones.solicitante.rut.estado = true;
        validaciones.solicitante.rut.mensaje = mensajeria.data.validations.rut.message_2;
        validaciones.validacion = false;
    }

    if (solicitante.nombre === null) {
        validaciones.solicitante.nombre.estado = true;
        validaciones.solicitante.nombre.mensaje = mensajeria.data.validations.nombre.message;
        validaciones.validacion = false;
    }

    if (solicitante.apellidoPaterno === null) {
        validaciones.solicitante.apellidoPaterno.estado = true;
        validaciones.solicitante.apellidoPaterno.mensaje = mensajeria.data.validations.apellido.message;
        validaciones.validacion = false;
    }

    if (solicitante.apellidoMaterno === null) {
        validaciones.solicitante.apellidoMaterno.estado = true;
        validaciones.solicitante.apellidoMaterno.mensaje = mensajeria.data.validations.apellido.message;
        validaciones.validacion = false;
    }

    if (solicitante.celular === null) {
        validaciones.solicitante.celular.estado = true;
        validaciones.solicitante.celular.mensaje = mensajeria.data.validations.celular.message;
        validaciones.validacion = false;
    }

    if (solicitante.correo === null) {
        validaciones.solicitante.correo.estado = true;
        validaciones.solicitante.correo.mensaje = mensajeria.data.validations.correo.message_1;
        validaciones.validacion = false;
    }

    if (comprador.cuenta.banco === null | comprador.cuenta.banco === '' && reclamo.tipoDeDevolucion === 2) {
        validaciones.cuenta.banco.estado = true;
        validaciones.cuenta.banco.mensaje = mensajeria.data.validations.banco.message;
        validaciones.validacion = false;
    }

    if (comprador.cuenta.tipo === null | comprador.cuenta.tipo === '' && reclamo.tipoDeDevolucion === 2) {
        validaciones.cuenta.tipo.estado = true;
        validaciones.cuenta.tipo.mensaje = mensajeria.data.validations.tipoCuenta.message;
        validaciones.validacion = false;
    }

    if (comprador.cuenta.numero === null | comprador.cuenta.numero === "" && reclamo.tipoDeDevolucion === 2) {
        validaciones.cuenta.numero.estado = true;
        validaciones.cuenta.numero.mensaje = mensajeria.data.validations.numeroCuenta.message;
        validaciones.validacion = false;
    }

    if (venta.transaccion === null | !formulario.reclamo.flag.flgBoletos && venta.transaccion !== null) {
        validaciones.venta.transaccion.estado = true;
        validaciones.venta.transaccion.mensaje = mensajeria.data.validations.transaccion.message;
        validaciones.validacion = false;
    }

    if (reclamo.comentario === null) {
        validaciones.reclamo.comentario.estado = true;
        validaciones.reclamo.comentario.mensaje = mensajeria.data.validations.comentario.message_1;
        validaciones.validacion = false;
    }

    if (boleto.listaBoletosAnular.length === 0) {
        validaciones.boleto.boletosAnular.estado = true;
        validaciones.boleto.boletosAnular.mensaje = mensajeria.data.validations.boleto.message_2;
        validaciones.validacion = false;
    }

    if (reclamo.tipoDeDevolucion === null) {
        validaciones.reclamo.tipoDeDevolucion.estado = true;
        validaciones.reclamo.tipoDeDevolucion.mensaje = mensajeria.data.validations.tipoDeDevolucion.message;
        validaciones.validacion = false;
    }

    return validaciones;
}

export async function validarTransaccion(event) {

    let validaciones = {
        numero: null,
        txtSpan: null,
        activeSpan: false
    }
    let mensajeria = await textos;

    let id = event.target.id;
    let number = event.target.value;

    switch (id) {
        case "trxsoli":
            if (number.length > 0) {
                if (number.length >= 8) {
                    validaciones.numero = number;
                    validaciones.txtSpan = null;
                    validaciones.activeSpan = false;
                } else {
                    validaciones.numero = null;
                    validaciones.txtSpan = mensajeria.data.validations.transaccion.message;
                    validaciones.activeSpan = true;
                }
            } else {
                validaciones.numero = null;
                validaciones.txtSpan = mensajeria.data.validations.transaccion.requerido;
                validaciones.activeSpan = true;

            }
            break;
        default:
            break;
    }

    return validaciones;
}

export async function obtenerCodigoLinea() {

    let e = getHost();

    switch (e) {
        case "turbus":
            return 1;
        case "condor":
            return 11;
        case "jac":
            return 26;
        case "biobio":
            return 14;
        default:
            return 1;
    }
}

export async function obtenerBancos() {
    let listaBancos = new Map();
    let mensajeria = await textos;
    try {
        listaBancos = mensajeria.data.bancos;
        listaBancos.sort((a, b) => { return a.nombre > b.nombre ? 1 : -1 });
    } catch (error) {
        listaBancos.set("0", "BANCOS NO DISPONIBLES");
    }
    return listaBancos;
}

export async function obtenerTipoDeCuenta() {
    let listaTiposDeCuentas = new Map();
    let mensajeria = await textos;
    try {
        listaTiposDeCuentas = mensajeria.data.tipoCuenta;
        listaTiposDeCuentas.sort((a, b) => { return a.nombre > b.nombre ? 1 : -1 });
    } catch (error) {
        listaTiposDeCuentas.set("0", "TIPOS DE CUENTA NO DISPONIBLE");
    }
    return listaTiposDeCuentas;
}

export async function obtenerTextos() {
    let response = {
        inStep: '',
        status: "",
        mensaje: '',
        texto: '',
        data: []
    }

    try {

        await axios.get("json/textos.json")
            .then((res) => {

                let textos = []

                res.data.map(texto => {
                    return textos.push(texto);
                })

                let e = getHost();

                switch (e) {
                    case "turbus":
                        textos = textos[0];
                        response.data = textos.TURBUS;
                        break;
                    case "condor":
                        textos = textos[1];
                        response.data = textos.CONDOR;
                        break;
                    case "jac":
                        textos = textos[2];
                        response.data = textos.JAC;
                        break;
                    case "biobio":
                        textos = textos[3];
                        response.data = textos.BIOBIO;
                        break;
                    default:
                        textos = textos[0];
                        response.data = textos.TURBUS;
                        break;
                }
            }).catch((error) => {

                response.inStep = 3;
                response.mensaje = jsonData.messages.obtenerTipoReclamo.error.titulo;
                response.texto = jsonData.messages.obtenerTipoReclamo.error.message;
                response.status = "warning"
            })

        return response;

    } catch (error) {

        response.inStep = 3;
        response.mensaje = jsonData.messages.obtenerTipoReclamo.fatal.titulo;
        response.texto = jsonData.messages.obtenerTipoReclamo.fatal.message;
        response.status = "error"
        response.data = error

        return response;
    }
}

export function getHost() {
    let e = '';

    if (params.indexOf('turbus') >= 0) {
        e = "turbus";
    } else if (params.indexOf('condor') >= 0) {
        e = "condor"
    } else if (params.indexOf('jac') >= 0) {
        e = "jac"
    } else if (params.indexOf('biobio') >= 0) {
        e = "biobio"
    }

    if (emp !== null) {
        switch (emp) {
            case "turbus":
                e = "turbus";
                break;
            case "condor":
                e = "condor";
                break;
            case "biobio":
                e = "biobio";
                break;
            case "jac":
                e = "jac";
                break;
            default:
                e = "turbus";
                break;
        }
    }
    return e;
}